import { render, staticRenderFns } from "./RelativeForwhomCustomer.vue?vue&type=template&id=0b29e70e&scoped=true"
import script from "./RelativeForwhomCustomer.vue?vue&type=script&lang=js"
export * from "./RelativeForwhomCustomer.vue?vue&type=script&lang=js"
import style0 from "./RelativeForwhomCustomer.vue?vue&type=style&index=0&id=0b29e70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29e70e",
  null
  
)

export default component.exports